import { createReducer } from '../../../utils/';
import { combineReducers } from 'redux';
import constant from './constant';


const userGroupsHandlers = {
    [constant.userGroups](state, action) {
        return action.payload;
    }
};

const userGroupHandlers = {
    [constant.userGroup](state, action) {
        return { ...state, ...action.payload };
    }
};

const usersHandlers = {
    [constant.users](state, action) {
        return action.payload;
    }
};

const loadingHandlers = {
    [constant.loading](state, action) {
        return action.payload;
    },
}

//Modal
const modalHandlers = {
    [constant.modal](state, action) {
        return { ...state, ...action.payload }
    }
};


const searchHandlers = {
    [constant.search](state, action) {
        return { ...state, ...action.payload }
    }
};

export const loading = createReducer(false, loadingHandlers);
export const search = createReducer({ page: 1, pageSize: 10 }, searchHandlers);
export const userGroups = createReducer([], userGroupsHandlers);
export const userGroupData = createReducer({ name: '', desc: '', users: [] }, userGroupHandlers);
export const users = createReducer([], usersHandlers);
//visible modal是否显示 disabled modal中select是否禁用 type modal用途'edit','add'
export const modal = createReducer({ visible: false, disabled: false, type: '' }, modalHandlers);

export const userGroup = combineReducers({
    loading,
    search,
    userGroups,
    userGroupData,
    users,
    modal,
})








// WEBPACK FOOTER //
// ./pages/user/userGroup/reducers.js